import App from "@/App.vue";

export default [
  {
    path: "/importacao-legado",
    name: "legacy_importation",
    component: App,
    redirect: { name: "list legacy_importation" },
    children: [
      {
        path: "",
        name: "list legacy_importation",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/LegacyImportationList.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Importação Legado",
              disabled: false,
              link: false,
              to: { name: "legacy_importation" }
            }
          ],
          displayName: "Importação Legado - Lockton",
          requiresAuth: true
        }
      }
    ]
  }
];
